import {Component, OnInit, ViewChild} from '@angular/core';
import {Package} from "../model/Package";
import {MatDialog, MatPaginator, Sort} from "@angular/material";
import { ProvidedService } from "../service/http/provided.service";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {merge, of as observableOf} from "rxjs";
import {catchError, map, startWith, switchMap} from "rxjs/operators";
import {AcceptDeclineDialogComponent} from "../dialog/accept-decline-dialog/accept-decline-dialog.component";

@Component({
  selector: 'app-provided',
  templateUrl: './provided.component.html',
  styleUrls: ['./provided.component.css']
})
export class ProvidedComponent implements OnInit {

  displayedColumns: string[] = ['id', 'identifier', 'pos', 'model', 'lang', 'status', 'creationDate'];
  data: Package[] = [];
  isLoadingResults = false;
  resultsLength = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private providedService: ProvidedService,
              private translate: TranslateService,
              private _router: Router,
              public dialog: MatDialog) { }

  ngOnInit() {
    this.loadTableData();
  }

  loadTableData() {

    merge(this.paginator.page)
      .pipe(
        startWith([]),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.providedService.getProvidedPackagesPagination(this.paginator.pageIndex + 1);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.resultsLength = data["totalElements"];
          return data["content"];
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return observableOf([]);
        })
      ).subscribe(data => {
      this.data = data;
    });
  }

  sortData(sort: Sort) {
    const data = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.data = data;
      return;
    }

    this.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'identifier': return this.compare(a.identifier, b.identifier, isAsc);
        case 'pos': return this.compare(a.pos, b.pos, isAsc);
        case 'model': return this.compare(a.model.name, b.model.name, isAsc);
        case 'lang': return this.compare(a.language.name, b.language.name, isAsc);
        case 'creationDate': return this.compare(a.creationDate, b.creationDate, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
